import React, { useState, useEffect } from "react";
import { Col, Row, Card, Button, Table, Spinner, Form, Alert, Modal, Dropdown, ButtonGroup } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faBuilding, faCaretDown, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { client } from "../../api/client";

/** Arbre d'accès superviseur (3.1 / 3.2 exclus) */
const ACCESS_TREE = [
  {
    code: "0", label: "TABLEAU DE BORD",
    children: [
      { code: "0.1", label: "Entreprise" },
      { code: "0.2", label: "ONLINE CLIENT" },
      { code: "0.3", label: "GESTION STOCK" },
      { code: "0.4", label: "Netoyer" },
      { code: "0.5", label: "Superviseur" },
      { code: "0.6", label: "Succursal" },
    ]
  },
  {
    code: "1", label: "AGENTS",
    children: [
      { code: "1.1", label: "Ajouter" },
      { code: "1.2", label: "Lister" },
      { code: "1.3", label: "Modifier" },
      { code: "1.4", label: "Supprimer" },
    ]
  },
  {
    code: "2", label: "POS",
    children: [
      { code: "2.1", label: "Ajouter" },
      { code: "2.2", label: "Lister" },
      { code: "2.3", label: "Activer / Desactiver" },
      { code: "2.4", label: "Modifier" },
      { code: "2.5", label: "Liaison Vendeur" },
      { code: "2.6", label: "Modifier Vendeur" },
      { code: "2.7", label: "Modifier pourcentage" },
      { code: "2.8", label: "Modifier prime" },
      { code: "2.9", label: "Supprimer" },
    ]
  },
  {
    code: "3", label: "PARAMETRE SYSTEME",
    children: [
      { code: "3.3", label: "Commune" },
      { code: "3.4", label: "Succursal" },
      { code: "3.5", label: "Primes" },
      { code: "3.6", label: "Motif eliminations" },
      { code: "3.7", label: "Tirages" },
      { code: "3.8", label: "Configurations systeme" },
    ]
  },
  {
    code: "4", label: "SURVEILLANCE",
    children: [
      { code: "4.1", label: "Vente par pos" },
      { code: "4.2", label: "Vente par pari" },
      { code: "4.3", label: "Fermeture vente" },
      {
        code: "4.4", label: "Lots gagnants",
        children: [{ code: "4.4.1", label: "Modifier lots gagnants" }]
      },
      { code: "4.5", label: "Tracabilite" },
      {
        code: "4.6", label: "Gestion bloquage",
        children: [
          { code: "4.6.1", label: "General" },
          { code: "4.6.2", label: "Agent" },
        ]
      },
      {
        code: "4.7", label: "Limite vente",
        children: [
          { code: "4.7.1", label: "General" },
          { code: "4.7.2", label: "Agent" },
          { code: "4.7.3", label: "Boule" },
        ]
      },
      {
        code: "4.8", label: "Controle",
        children: [
          { code: "4.8.1", label: "Depot" },
          { code: "4.8.2", label: "Retrait" },
          { code: "4.8.3", label: "Transaction" },
          { code: "4.8.4", label: "Paiement commission" },
        ]
      },
    ]
  },
  {
    code: "5", label: "RAPPORT",
    children: [
      { code: "5.1", label: "Vente" },
      { code: "5.2", label: "Fiches vendu" },
      { code: "5.3", label: "Fiches gagnant" },
      { code: "5.4", label: "Fiches eliminer" },
      { code: "5.5", label: "Supprimer fiche" },
    ]
  },
];

const collectCodes = (nodes) => {
  const out = [];
  const walk = (list) => {
    (list || []).forEach(n => {
      out.push(n.code);
      if (n.children) walk(n.children);
    });
  };
  walk(nodes);
  return out;
};

const emptyBranchForm = {
  name: "",
  zone_name: "",
  supervisor: "",
  supervisor_commission_rate: "2.00",
  is_active: true,
  display_name: "",
  branch_phone: "",
  branch_address: "",
  branch_description: "",
  branch_footer_message: ""
};

const emptySupForm = {
  first_name: "",
  last_name: "",
  username: "",
  password: "",
  confirm_password: "",
  phone_number: "",
  email: "",
  sex: "M",
  branch: "",
  supervisor_commission_rate: "2.00",
  is_active: true
};

export function Branches() {
  const [branches, setBranches] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [loading, setLoading] = useState(true);
  // list-active | list-inactive | add | list-supervisors | add-supervisor
  const [viewMode, setViewMode] = useState("list-active");
  const [searchQuery, setSearchQuery] = useState("");

  const [form, setForm] = useState({ ...emptyBranchForm });
  const [addLogoFile, setAddLogoFile] = useState(null);
  const [addLogoPreview, setAddLogoPreview] = useState(null);
  const [formError, setFormError] = useState("");
  const [saving, setSaving] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState({ id: "", ...emptyBranchForm });
  const [editLogoFile, setEditLogoFile] = useState(null);
  const [editLogoPreview, setEditLogoPreview] = useState(null);
  const [removeEditLogo, setRemoveEditLogo] = useState(false);
  const [editError, setEditError] = useState("");

  const [supForm, setSupForm] = useState({ ...emptySupForm });
  const [supFormError, setSupFormError] = useState("");

  const [showEditSupModal, setShowEditSupModal] = useState(false);
  const [editSupForm, setEditSupForm] = useState({ id: "", ...emptySupForm, password: "", confirm_password: "" });
  const [editSupError, setEditSupError] = useState("");

  // Liste Accès
  const [accessSupervisor, setAccessSupervisor] = useState(null);
  const [accessCodes, setAccessCodes] = useState([]);
  const [accessLoading, setAccessLoading] = useState(false);
  const [accessSaving, setAccessSaving] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const bData = await client("branches/");
      if (bData && bData.error) {
        console.error("Branches API error:", bData.error);
        setBranches([]);
      } else {
        const bList = bData ? (bData.results || (Array.isArray(bData) ? bData : [])) : [];
        setBranches(bList);
      }

      const sData = await client("supervisors/");
      if (sData && sData.error) {
        console.error("Supervisors API error:", sData.error);
        setSupervisors([]);
      } else {
        const sList = sData ? (sData.results || (Array.isArray(sData) ? sData : [])) : [];
        setSupervisors(sList);
      }
    } catch (e) {
      console.error("Error fetching data:", e);
      setBranches([]);
      setSupervisors([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (viewMode === "list-supervisors" || viewMode === "add-supervisor") {
      fetchData();
    }
  }, [viewMode]);

  const submitBranchBranding = async (branchId, brandingData, logoFile, shouldRemoveLogo = false) => {
    if (logoFile) {
      const fd = new FormData();
      fd.append("branch_logo", logoFile);
      fd.append("display_name", brandingData.display_name || "");
      fd.append("branch_phone", brandingData.branch_phone || "");
      fd.append("branch_address", brandingData.branch_address || "");
      fd.append("branch_description", brandingData.branch_description || "");
      fd.append("branch_footer_message", brandingData.branch_footer_message || "");
      await client(`branches/${branchId}/branding/`, { method: "PATCH", body: fd });
    } else {
      const body = {
        display_name: brandingData.display_name || null,
        branch_phone: brandingData.branch_phone || null,
        branch_address: brandingData.branch_address || null,
        branch_description: brandingData.branch_description || null,
        branch_footer_message: brandingData.branch_footer_message || null,
      };
      if (shouldRemoveLogo) {
        body.branch_logo = "";
      }
      await client(`branches/${branchId}/branding/`, { method: "PATCH", body });
    }
  };

  const handleCreateBranch = async (e) => {
    e.preventDefault();
    setFormError("");
    if (!form.name.trim()) {
      setFormError("Le nom de la succursale est requis.");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        name: form.name,
        zone_name: form.zone_name,
        supervisor: form.supervisor || null,
        supervisor_commission_rate: parseFloat(form.supervisor_commission_rate) || 0,
        is_active: form.is_active,
        display_name: form.display_name || null,
        branch_phone: form.branch_phone || null,
        branch_address: form.branch_address || null,
        branch_description: form.branch_description || null,
        branch_footer_message: form.branch_footer_message || null,
      };
      const createdBranch = await client("branches/", { method: "POST", body: payload });
      const hasBrandingFields = Boolean(
        addLogoFile ||
        form.display_name?.trim() ||
        form.branch_phone?.trim() ||
        form.branch_address?.trim() ||
        form.branch_description?.trim() ||
        form.branch_footer_message?.trim()
      );
      if (createdBranch?.id && hasBrandingFields) {
        await submitBranchBranding(createdBranch.id, form, addLogoFile, false);
      }
      alert("Succursale créée avec succès !");
      setForm({ ...emptyBranchForm });
      setAddLogoFile(null);
      setAddLogoPreview(null);
      await fetchData();
      setViewMode(form.is_active ? "list-active" : "list-inactive");
    } catch (err) {
      setFormError(err.error || err.detail || err.message || "Erreur lors de la création de la succursale.");
    } finally {
      setSaving(false);
    }
  };

  const handleOpenEdit = (branch) => {
    const supId = typeof branch.supervisor === "object" ? (branch.supervisor?.id || "") : (branch.supervisor || "");
    setEditForm({
      id: branch.id,
      name: branch.name || "",
      zone_name: branch.zone_name || "",
      supervisor: supId,
      supervisor_commission_rate: branch.supervisor_commission_rate != null ? String(branch.supervisor_commission_rate) : "2.00",
      is_active: branch.is_active ?? true,
      display_name: branch.display_name || "",
      branch_phone: branch.branch_phone || "",
      branch_address: branch.branch_address || "",
      branch_description: branch.branch_description || "",
      branch_footer_message: branch.branch_footer_message || "",
      branch_logo_url: branch.branch_logo_url || null,
      effective_logo_url: branch.effective_branding?.logo_url || null,
    });
    setEditLogoFile(null);
    setEditLogoPreview(branch.branch_logo_url || null);
    setRemoveEditLogo(false);
    setEditError("");
    setShowEditModal(true);
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    setEditError("");
    setSaving(true);
    try {
      const userRole = (() => {
        try { return JSON.parse(localStorage.getItem("user_profile") || "null")?.role; } catch { return null; }
      })();
      if (userRole === "COMPANY_ADMIN" || userRole === "SUPERADMIN") {
        const payload = {
          name: editForm.name,
          zone_name: editForm.zone_name,
          supervisor: editForm.supervisor || null,
          supervisor_commission_rate: parseFloat(editForm.supervisor_commission_rate) || 0,
          is_active: editForm.is_active,
          display_name: editForm.display_name || null,
          branch_phone: editForm.branch_phone || null,
          branch_address: editForm.branch_address || null,
          branch_description: editForm.branch_description || null,
          branch_footer_message: editForm.branch_footer_message || null,
        };
        await client(`branches/${editForm.id}/`, { method: "PUT", body: payload });
      }
      await submitBranchBranding(editForm.id, editForm, editLogoFile, removeEditLogo);
      alert("Succursale mise à jour avec succès !");
      setShowEditModal(false);
      await fetchData();
    } catch (err) {
      setEditError(err.error || err.detail || err.message || "Erreur lors de la mise à jour.");
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteBranch = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette succursale ?")) return;
    try {
      await client(`branches/${id}/`, { method: "DELETE" });
      alert("Succursale supprimée avec succès !");
      fetchData();
    } catch (err) {
      alert(err.error || err.detail || err.message || "Erreur lors de la suppression.");
    }
  };

  const handleToggleStatus = async (branch) => {
    try {
      await client(`branches/${branch.id}/`, {
        method: "PUT",
        body: { is_active: !branch.is_active }
      });
      fetchData();
    } catch (e) {
      console.error("Toggle status error:", e);
    }
  };

  const handleCreateSupervisor = async (e) => {
    e.preventDefault();
    setSupFormError("");
    if (!supForm.username.trim()) {
      setSupFormError("Le nom d'utilisateur est requis.");
      return;
    }
    if (!supForm.password) {
      setSupFormError("Le mot de passe est requis.");
      return;
    }
    if (supForm.password !== supForm.confirm_password) {
      setSupFormError("Les mots de passe ne correspondent pas.");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        first_name: supForm.first_name,
        last_name: supForm.last_name,
        username: supForm.username.trim(),
        password: supForm.password,
        phone_number: supForm.phone_number,
        email: supForm.email,
        sex: supForm.sex,
        branch: supForm.branch || null,
        supervisor_commission_rate: parseFloat(supForm.supervisor_commission_rate) || 0,
        is_active: supForm.is_active
      };
      await client("supervisors/", { method: "POST", body: payload });
      alert("Superviseur créé avec succès !");
      setSupForm({ ...emptySupForm });
      await fetchData();
      setViewMode("list-supervisors");
    } catch (err) {
      setSupFormError(err.error || err.detail || err.message || "Erreur lors de la création du superviseur.");
    } finally {
      setSaving(false);
    }
  };

  const handleOpenEditSup = (sup) => {
    const branchId = typeof sup.branch === "object" ? (sup.branch?.id || "") : (sup.branch || sup.managed_branch_id || "");
    setEditSupForm({
      id: sup.id,
      first_name: sup.first_name || "",
      last_name: sup.last_name || "",
      username: sup.username || "",
      password: "",
      confirm_password: "",
      phone_number: sup.phone_number || "",
      email: sup.email || "",
      sex: sup.sex || "M",
      branch: branchId || "",
      supervisor_commission_rate: sup.supervisor_commission_rate != null ? String(sup.supervisor_commission_rate) : "2.00",
      is_active: sup.is_active ?? true
    });
    setEditSupError("");
    setShowEditSupModal(true);
  };

  const handleSaveEditSup = async (e) => {
    e.preventDefault();
    setEditSupError("");
    if (editSupForm.password && editSupForm.password !== editSupForm.confirm_password) {
      setEditSupError("Les mots de passe ne correspondent pas.");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        first_name: editSupForm.first_name,
        last_name: editSupForm.last_name,
        username: editSupForm.username.trim(),
        phone_number: editSupForm.phone_number,
        email: editSupForm.email,
        sex: editSupForm.sex,
        branch: editSupForm.branch || null,
        supervisor_commission_rate: parseFloat(editSupForm.supervisor_commission_rate) || 0,
        is_active: editSupForm.is_active
      };
      if (editSupForm.password) payload.password = editSupForm.password;
      await client(`supervisors/${editSupForm.id}/`, { method: "PUT", body: payload });
      alert("Superviseur mis à jour avec succès !");
      setShowEditSupModal(false);
      await fetchData();
    } catch (err) {
      setEditSupError(err.error || err.detail || err.message || "Erreur lors de la mise à jour.");
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteSupervisor = async (id) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce superviseur ?")) return;
    try {
      await client(`supervisors/${id}/`, { method: "DELETE" });
      alert("Superviseur supprimé avec succès !");
      fetchData();
    } catch (err) {
      alert(err.error || err.detail || err.message || "Erreur lors de la suppression.");
    }
  };

  const handleToggleSupStatus = async (sup) => {
    try {
      await client(`supervisors/${sup.id}/`, {
        method: "PUT",
        body: { is_active: !sup.is_active }
      });
      fetchData();
    } catch (e) {
      console.error("Toggle supervisor status error:", e);
    }
  };

  const openAccessList = async (sup) => {
    setAccessSupervisor(sup);
    setAccessCodes([]);
    setAccessLoading(true);
    setViewMode("supervisor-access");
    try {
      const perms = await client(`supervisor/permissions/${sup.id}/`);
      setAccessCodes(Array.isArray(perms?.access_codes) ? perms.access_codes : []);
    } catch (e) {
      console.error("Error loading access list:", e);
      setAccessCodes([]);
    } finally {
      setAccessLoading(false);
    }
  };

  const toggleAccessCode = (node) => {
    const selfAndDesc = collectCodes([node]);
    const currentlyOn = accessCodes.includes(node.code);
    setAccessCodes(prev => {
      if (currentlyOn) {
        return prev.filter(c => !selfAndDesc.includes(c));
      }
      const next = new Set([...prev, ...selfAndDesc]);
      return Array.from(next);
    });
  };

  const saveAccessList = async () => {
    if (!accessSupervisor) return;
    setAccessSaving(true);
    try {
      await client(`supervisor/permissions/${accessSupervisor.id}/`, {
        method: "PUT",
        body: { access_codes: accessCodes }
      });
      alert("Liste d'accès enregistrée !");
      setViewMode("list-supervisors");
      setAccessSupervisor(null);
    } catch (err) {
      alert(err.error || err.detail || err.message || "Erreur lors de l'enregistrement des accès.");
    } finally {
      setAccessSaving(false);
    }
  };

  const renderAccessNode = (node, depth = 0, isLast = true, ancestorsLast = []) => {
    const checked = accessCodes.includes(node.code);
    const hasChildren = node.children && node.children.length > 0;
    const indent = depth * 22;

    return (
      <div key={node.code} style={{ position: 'relative' }}>
        <div
          className="d-flex align-items-center"
          style={{
            padding: '3px 0',
            paddingLeft: `${indent}px`,
            color: '#E05A2B',
            fontSize: depth === 0 ? '0.95rem' : '0.9rem',
            fontWeight: depth === 0 ? 700 : 400,
            position: 'relative'
          }}
        >
          {depth > 0 && (
            <>
              {/* vertical connectors from ancestors */}
              {ancestorsLast.map((ancIsLast, i) => (
                !ancIsLast ? (
                  <span
                    key={i}
                    style={{
                      position: 'absolute',
                      left: `${i * 22 + 10}px`,
                      top: 0,
                      bottom: 0,
                      width: '1px',
                      backgroundColor: '#CFCFCF'
                    }}
                  />
                ) : null
              ))}
              <span
                style={{
                  position: 'absolute',
                  left: `${(depth - 1) * 22 + 10}px`,
                  top: 0,
                  height: '50%',
                  width: '1px',
                  backgroundColor: '#CFCFCF'
                }}
              />
              {!isLast && (
                <span
                  style={{
                    position: 'absolute',
                    left: `${(depth - 1) * 22 + 10}px`,
                    top: '50%',
                    bottom: 0,
                    width: '1px',
                    backgroundColor: '#CFCFCF'
                  }}
                />
              )}
              <span
                style={{
                  position: 'absolute',
                  left: `${(depth - 1) * 22 + 10}px`,
                  top: '50%',
                  width: '12px',
                  height: '1px',
                  backgroundColor: '#CFCFCF'
                }}
              />
            </>
          )}
          <Form.Check
            type="checkbox"
            checked={checked}
            onChange={() => toggleAccessCode(node)}
            style={{ marginRight: '8px', marginBottom: 0 }}
            id={`access-${node.code}`}
          />
          <label htmlFor={`access-${node.code}`} style={{ cursor: 'pointer', marginBottom: 0, color: '#E05A2B' }}>
            {node.code} - {node.label}
          </label>
        </div>
        {hasChildren && node.children.map((child, idx) =>
          renderAccessNode(child, depth + 1, idx === node.children.length - 1, [...ancestorsLast, isLast])
        )}
      </div>
    );
  };

  const getSupervisorName = (branch) => {
    if (branch.supervisor_name) return branch.supervisor_name;
    if (!branch.supervisor) return null;
    const supId = typeof branch.supervisor === 'object' ? branch.supervisor.id : branch.supervisor;
    const sup = supervisors.find(s => String(s.id) === String(supId));
    if (!sup) return null;
    if (sup.first_name || sup.last_name) {
      return `${sup.first_name || ''} ${sup.last_name || ''}`.trim();
    }
    return sup.username;
  };

  const getFilteredBranches = () => {
    const wantActive = viewMode === "list-active";
    const q = searchQuery.toLowerCase();
    return branches.filter(b => {
      const supName = getSupervisorName(b) || "";
      const dispName = b.display_name || b.effective_branding?.company_name || "";
      const footerMsg = b.branch_footer_message || b.effective_branding?.ticket_footer_message || "";
      const matchesSearch =
        (b.name || "").toLowerCase().includes(q) ||
        (b.zone_name || "").toLowerCase().includes(q) ||
        dispName.toLowerCase().includes(q) ||
        footerMsg.toLowerCase().includes(q) ||
        supName.toLowerCase().includes(q);
      const isActive = b.is_active ?? true;
      return matchesSearch && (Boolean(isActive) === wantActive);
    });
  };

  const getFilteredSupervisors = () => {
    const q = searchQuery.toLowerCase();
    return supervisors.filter(s => {
      return (
        (s.username || "").toLowerCase().includes(q) ||
        (s.first_name || "").toLowerCase().includes(q) ||
        (s.last_name || "").toLowerCase().includes(q) ||
        (s.branch_name || "").toLowerCase().includes(q) ||
        (s.managed_branch_name || "").toLowerCase().includes(q) ||
        (s.phone_number || "").toLowerCase().includes(q)
      );
    });
  };

  const filtered = getFilteredBranches();
  const filteredSups = getFilteredSupervisors();
  const isSupView = viewMode === "list-supervisors" || viewMode === "add-supervisor" || viewMode === "supervisor-access";
  const currentUser = (() => {
    try { return JSON.parse(localStorage.getItem("user_profile") || "null"); } catch { return null; }
  })();
  const isCompanyAdmin = currentUser?.role === "COMPANY_ADMIN" || currentUser?.role === "SUPERADMIN";
  const isSupervisorUser = currentUser?.role === "SUPERVISOR";

  const accessDisplayName = accessSupervisor
    ? (accessSupervisor.first_name || accessSupervisor.last_name
      ? `${accessSupervisor.first_name || ''} ${accessSupervisor.last_name || ''}`.trim()
      : accessSupervisor.username)
    : "";

  const tabBtn = (active, colors) => ({
    borderRadius: '4px',
    fontSize: '0.9rem',
    padding: '6px 20px',
    fontWeight: '500',
    ...(active ? colors.active : colors.idle)
  });

  return (
    <div style={{ padding: '16px 0' }}>
      {/* Header Tabs */}
      <div className="d-flex mb-4 flex-wrap" style={{ gap: '10px' }}>
        {isCompanyAdmin && (
          <Button
            style={tabBtn(viewMode === "add", {
              active: { backgroundColor: '#007BFF', borderColor: '#007BFF', color: '#FFF' },
              idle: { backgroundColor: '#007BFF', borderColor: '#007BFF', color: '#FFF' }
            })}
            onClick={() => { setViewMode("add"); setSearchQuery(""); }}
          >
            Ajouter
          </Button>
        )}
        <Button
          variant={viewMode === "list-active" ? "success" : "outline-success"}
          style={{
            borderRadius: '4px',
            fontSize: '0.9rem',
            padding: '6px 20px',
            fontWeight: '500',
            color: viewMode === "list-active" ? '#FFF' : undefined
          }}
          onClick={() => { setViewMode("list-active"); setSearchQuery(""); }}
        >
          Lister Actif
        </Button>
        {isCompanyAdmin && (
          <Button
            variant={viewMode === "list-inactive" ? "warning" : "outline-warning"}
            style={{
              borderRadius: '4px',
              fontSize: '0.9rem',
              padding: '6px 20px',
              fontWeight: '500',
              color: viewMode === "list-inactive" ? '#222' : undefined
            }}
            onClick={() => { setViewMode("list-inactive"); setSearchQuery(""); }}
          >
            Lister Inactif
          </Button>
        )}
        {isCompanyAdmin && (
          <Button
            style={tabBtn(isSupView, {
              active: { backgroundColor: '#6F42C1', borderColor: '#6F42C1', color: '#FFF' },
              idle: { backgroundColor: '#FFF', borderColor: '#6F42C1', color: '#6F42C1' }
            })}
            onClick={() => { setViewMode("list-supervisors"); setSearchQuery(""); }}
          >
            Superviseur
          </Button>
        )}
        {isSupervisorUser && (
          <span className="align-self-center small text-muted fw-bold">
            Succursale assignée uniquement
          </span>
        )}
      </div>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <div className="text-muted small mt-2">Chargement...</div>
        </div>
      ) : viewMode === "add" ? (
        /* Add Branch Form */
        <Card className="border-0 shadow-sm" style={{ borderRadius: '8px', padding: '24px' }}>
          {formError && <Alert variant="danger" className="py-2 px-3 small mb-3">{formError}</Alert>}
          <Form onSubmit={handleCreateBranch}>
            <Row className="mb-3">
              <Col xs={12} md={6} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Nom de la succursale *</Form.Label>
                <div className="position-relative d-flex align-items-center">
                  <Form.Control
                    type="text"
                    style={{ borderColor: form.name.trim() ? '#28A745' : '#DC3545', paddingRight: '36px', borderRadius: '4px', height: '38px' }}
                    placeholder="Ex: Succursale Nord"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                  />
                  <FontAwesomeIcon icon={form.name.trim() ? faCheck : faTimes} className={form.name.trim() ? "text-success" : "text-danger"} style={{ position: 'absolute', right: '12px', pointerEvents: 'none' }} />
                </div>
              </Col>
              <Col xs={12} md={6} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Zone / Emplacement</Form.Label>
                <Form.Control
                  type="text"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  placeholder="Ex: Port-au-Prince"
                  value={form.zone_name}
                  onChange={(e) => setForm({ ...form, zone_name: e.target.value })}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} md={6} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Superviseur</Form.Label>
                <Form.Control
                  as="select"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={form.supervisor}
                  onChange={(e) => setForm({ ...form, supervisor: e.target.value })}
                >
                  <option value="">Sélectionner un superviseur...</option>
                  {supervisors.map(s => (
                    <option key={s.id} value={s.id}>
                      {s.first_name || s.last_name ? `${s.first_name} ${s.last_name} (${s.username})` : s.username}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col xs={12} md={6} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>% Commission Superviseur</Form.Label>
                <div className="position-relative d-flex align-items-center">
                  <Form.Control
                    type="number"
                    step="0.01"
                    min="0"
                    style={{ borderColor: '#28A745', paddingRight: '48px', borderRadius: '4px', height: '38px' }}
                    value={form.supervisor_commission_rate}
                    onChange={(e) => setForm({ ...form, supervisor_commission_rate: e.target.value })}
                  />
                  <span style={{ position: 'absolute', right: '12px', fontSize: '0.85rem', color: '#888', fontWeight: 'bold' }}>%</span>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} md={6} className="mb-2 d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  id="active-switch"
                  label="Succursale Active"
                  checked={form.is_active}
                  onChange={(e) => setForm({ ...form, is_active: e.target.checked })}
                  style={{ cursor: 'pointer', fontWeight: '500' }}
                />
              </Col>
            </Row>

            {/* Section Branding & Fiche de la Succursale */}
            <div className="border rounded p-3 mb-4" style={{ backgroundColor: '#FAFAFA', borderColor: '#E5E5E5' }}>
              <h6 className="fw-bold mb-1" style={{ color: '#007BFF' }}>
                Branding & Fiche de la Succursale (Optionnel)
              </h6>
              <div className="text-muted small mb-3">
                Personnalisez l'identité imprimée sur les fiches de cette succursale. Si vide, les informations de la compagnie sont utilisées.
              </div>
              <Row className="mb-3">
                <Col xs={12} md={6} className="mb-2">
                  <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>
                    Nom Borlette / Nom Bank affiché
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ borderRadius: '4px', height: '38px' }}
                    placeholder="Laisser vide pour utiliser le nom de la compagnie"
                    value={form.display_name}
                    onChange={(e) => setForm({ ...form, display_name: e.target.value })}
                  />
                </Col>
                <Col xs={12} md={6} className="mb-2">
                  <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>
                    Logo de la succursale
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    style={{ borderRadius: '4px' }}
                    onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      setAddLogoFile(file);
                      setAddLogoPreview(file ? URL.createObjectURL(file) : null);
                    }}
                  />
                  {addLogoPreview && (
                    <div className="mt-2 d-flex align-items-center" style={{ gap: '10px' }}>
                      <img
                        src={addLogoPreview}
                        alt="Aperçu logo succursale"
                        style={{ height: '42px', width: 'auto', borderRadius: '4px', border: '1px solid #DDD', padding: '2px', background: '#FFF' }}
                      />
                      <Button
                        variant="outline-danger"
                        size="sm"
                        type="button"
                        onClick={() => { setAddLogoFile(null); setAddLogoPreview(null); }}
                      >
                        Retirer
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} md={6} className="mb-2">
                  <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>
                    Téléphone de la succursale
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ borderRadius: '4px', height: '38px' }}
                    placeholder="Ex: +509 3700-0000"
                    value={form.branch_phone}
                    onChange={(e) => setForm({ ...form, branch_phone: e.target.value })}
                  />
                </Col>
                <Col xs={12} md={6} className="mb-2">
                  <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>
                    Adresse de la succursale
                  </Form.Label>
                  <Form.Control
                    type="text"
                    style={{ borderRadius: '4px', height: '38px' }}
                    placeholder="Ex: Rue Capois #12, Port-au-Prince"
                    value={form.branch_address}
                    onChange={(e) => setForm({ ...form, branch_address: e.target.value })}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} className="mb-2">
                  <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>
                    Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    style={{ borderRadius: '4px' }}
                    placeholder="Description optionnelle de la succursale..."
                    value={form.branch_description}
                    onChange={(e) => setForm({ ...form, branch_description: e.target.value })}
                  />
                </Col>
                <Col xs={12} md={6} className="mb-2">
                  <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>
                    Message Fiche / Footer du ticket
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    style={{ borderRadius: '4px' }}
                    placeholder="Ex: Bòn chans! Fiche sa valab pou 90 jou"
                    value={form.branch_footer_message}
                    onChange={(e) => setForm({ ...form, branch_footer_message: e.target.value })}
                  />
                </Col>
              </Row>
            </div>

            <Button type="submit" className="w-100 py-2 fw-bold text-white mb-2" style={{ backgroundColor: '#007BFF', borderColor: '#007BFF', borderRadius: '4px', fontSize: '1rem' }} disabled={saving}>
              {saving ? <Spinner animation="border" size="sm" /> : "Enregistrer"}
            </Button>
            <Button variant="outline-secondary" className="w-100 py-2 fw-bold" style={{ borderRadius: '4px', fontSize: '1rem' }} onClick={() => setViewMode("list-active")}>
              Annuler
            </Button>
          </Form>
        </Card>
      ) : viewMode === "add-supervisor" ? (
        /* Add Supervisor Form */
        <Card className="border-0 shadow-sm" style={{ borderRadius: '8px', padding: '24px' }}>
          <h5 className="mb-3" style={{ fontWeight: 'bold', color: '#333' }}>Ajouter un superviseur</h5>
          {supFormError && <Alert variant="danger" className="py-2 px-3 small mb-3">{supFormError}</Alert>}
          <Form onSubmit={handleCreateSupervisor}>
            <Row className="mb-3">
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Prénom</Form.Label>
                <Form.Control
                  type="text"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.first_name}
                  onChange={(e) => setSupForm({ ...supForm, first_name: e.target.value })}
                />
              </Col>
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Nom</Form.Label>
                <Form.Control
                  type="text"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.last_name}
                  onChange={(e) => setSupForm({ ...supForm, last_name: e.target.value })}
                />
              </Col>
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Sexe</Form.Label>
                <Form.Control
                  as="select"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.sex}
                  onChange={(e) => setSupForm({ ...supForm, sex: e.target.value })}
                >
                  <option value="M">Masculin</option>
                  <option value="F">Féminin</option>
                </Form.Control>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Nom d'utilisateur *</Form.Label>
                <div className="position-relative d-flex align-items-center">
                  <Form.Control
                    type="text"
                    style={{ borderColor: supForm.username.trim() ? '#28A745' : '#DC3545', paddingRight: '36px', borderRadius: '4px', height: '38px' }}
                    value={supForm.username}
                    onChange={(e) => setSupForm({ ...supForm, username: e.target.value })}
                    required
                  />
                  <FontAwesomeIcon icon={supForm.username.trim() ? faCheck : faTimes} className={supForm.username.trim() ? "text-success" : "text-danger"} style={{ position: 'absolute', right: '12px', pointerEvents: 'none' }} />
                </div>
              </Col>
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Mot de passe *</Form.Label>
                <Form.Control
                  type="password"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.password}
                  onChange={(e) => setSupForm({ ...supForm, password: e.target.value })}
                  required
                />
              </Col>
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Confirmer mot de passe *</Form.Label>
                <Form.Control
                  type="password"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.confirm_password}
                  onChange={(e) => setSupForm({ ...supForm, confirm_password: e.target.value })}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Téléphone</Form.Label>
                <Form.Control
                  type="text"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.phone_number}
                  onChange={(e) => setSupForm({ ...supForm, phone_number: e.target.value })}
                />
              </Col>
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Email</Form.Label>
                <Form.Control
                  type="email"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.email}
                  onChange={(e) => setSupForm({ ...supForm, email: e.target.value })}
                />
              </Col>
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>Succursale</Form.Label>
                <Form.Control
                  as="select"
                  style={{ borderColor: '#28A745', borderRadius: '4px', height: '38px' }}
                  value={supForm.branch}
                  onChange={(e) => {
                    const branchId = e.target.value;
                    const br = branches.find(b => String(b.id) === String(branchId));
                    setSupForm({
                      ...supForm,
                      branch: branchId,
                      supervisor_commission_rate: br?.supervisor_commission_rate != null
                        ? String(br.supervisor_commission_rate)
                        : supForm.supervisor_commission_rate
                    });
                  }}
                >
                  <option value="">Sélectionner une succursale...</option>
                  {branches.map(b => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} md={4} className="mb-2">
                <Form.Label className="fw-bold small mb-1" style={{ color: '#333' }}>% Commission Superviseur</Form.Label>
                <div className="position-relative d-flex align-items-center">
                  <Form.Control
                    type="number"
                    step="0.01"
                    min="0"
                    style={{ borderColor: '#28A745', paddingRight: '48px', borderRadius: '4px', height: '38px' }}
                    value={supForm.supervisor_commission_rate}
                    onChange={(e) => setSupForm({ ...supForm, supervisor_commission_rate: e.target.value })}
                  />
                  <span style={{ position: 'absolute', right: '12px', fontSize: '0.85rem', color: '#888', fontWeight: 'bold' }}>%</span>
                </div>
              </Col>
              <Col xs={12} md={4} className="mb-2 d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  id="sup-active-switch"
                  label="Superviseur Actif"
                  checked={supForm.is_active}
                  onChange={(e) => setSupForm({ ...supForm, is_active: e.target.checked })}
                  style={{ cursor: 'pointer', fontWeight: '500' }}
                />
              </Col>
            </Row>
            <Button type="submit" className="w-100 py-2 fw-bold text-white mb-2" style={{ backgroundColor: '#007BFF', borderColor: '#007BFF', borderRadius: '4px', fontSize: '1rem' }} disabled={saving}>
              {saving ? <Spinner animation="border" size="sm" /> : "Enregistrer"}
            </Button>
            <Button variant="outline-secondary" className="w-100 py-2 fw-bold" style={{ borderRadius: '4px', fontSize: '1rem' }} onClick={() => setViewMode("list-supervisors")}>
              Annuler
            </Button>
          </Form>
        </Card>
      ) : viewMode === "supervisor-access" ? (
        <Card className="border-0 shadow-sm" style={{ borderRadius: '8px', padding: '24px' }}>
          <h4 className="mb-3" style={{ fontWeight: 'bold', color: '#222' }}>
            Acces : {accessDisplayName}
          </h4>
          <div className="mb-2" style={{ fontWeight: 600, color: '#333' }}>Fonctionnalité</div>
          <Card className="border shadow-none mb-4" style={{ borderRadius: '6px', borderColor: '#E5E5E5' }}>
            <Card.Body style={{ padding: '16px 20px' }}>
              {accessLoading ? (
                <div className="text-center py-4">
                  <Spinner animation="border" size="sm" />
                  <span className="ms-2 text-muted small">Chargement des accès...</span>
                </div>
              ) : (
                ACCESS_TREE.map((node, idx) =>
                  renderAccessNode(node, 0, idx === ACCESS_TREE.length - 1, [])
                )
              )}
            </Card.Body>
          </Card>
          <Button
            className="w-100 py-2 fw-bold text-white mb-2"
            style={{ backgroundColor: '#007BFF', borderColor: '#007BFF', borderRadius: '4px', fontSize: '1rem' }}
            onClick={saveAccessList}
            disabled={accessSaving || accessLoading}
          >
            {accessSaving ? <Spinner animation="border" size="sm" /> : "Enregistrer"}
          </Button>
          <Button
            variant="outline-secondary"
            className="w-100 py-2 fw-bold"
            style={{ borderRadius: '4px', fontSize: '1rem' }}
            onClick={() => { setViewMode("list-supervisors"); setAccessSupervisor(null); }}
          >
            Retour
          </Button>
        </Card>
      ) : viewMode === "list-supervisors" ? (
        /* Supervisors List */
        <Card className="border-0 shadow-sm" style={{ borderRadius: '8px' }}>
          <Card.Header className="bg-white border-0 py-3">
            <Row className="align-items-center">
              <Col>
                <h4 style={{ fontWeight: 'bold', color: '#6F42C1', margin: 0, textTransform: 'uppercase' }}>
                  Superviseurs
                </h4>
              </Col>
              <Col xs="auto">
                <Button
                  style={{ backgroundColor: '#007BFF', borderColor: '#007BFF', color: '#FFF', borderRadius: '4px', fontSize: '0.9rem', padding: '6px 20px', fontWeight: '500' }}
                  onClick={() => { setSupForm({ ...emptySupForm }); setSupFormError(""); setViewMode("add-supervisor"); }}
                >
                  Ajouter superviseur
                </Button>
              </Col>
            </Row>
          </Card.Header>

          <div className="px-3 pb-3 d-flex justify-content-between align-items-center flex-wrap" style={{ gap: '10px' }}>
            <div className="d-flex" style={{ gap: '4px' }}>
              {["COPIER", "EXCEL", "PDF", "IMPRIMER"].map((label, idx) => (
                <button
                  key={idx}
                  style={{ backgroundColor: '#F5F5F5', border: '1px solid #CCCCCC', color: '#333333', fontSize: '0.78rem', padding: '6px 16px', borderRadius: '2px', height: '34px', fontWeight: 'normal', outline: 'none' }}
                  onClick={() => alert(`${label} cliqué`)}
                >
                  {label}
                </button>
              ))}
            </div>
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
              <span className="fw-bold small text-dark" style={{ fontSize: '0.92rem' }}>Search:</span>
              <Form.Control
                type="text"
                size="sm"
                style={{ width: '220px', borderRadius: '4px', border: '1px solid #CCC' }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="table-responsive" style={{ padding: '0 16px 16px 16px' }}>
            <Table bordered hover className="align-items-center mb-0" style={{ borderCollapse: 'collapse', borderColor: '#DDD' }}>
              <thead>
                <tr style={{ backgroundColor: '#F8F9FA' }}>
                  <th style={{ width: '90px', padding: '12px 8px', textAlign: 'center' }}></th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Liste Accès <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Superviseur <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Username <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Succursale <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    % Commission <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Téléphone <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Statut <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredSups.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center py-4 text-muted">Aucun superviseur trouvé.</td>
                  </tr>
                ) : (
                  filteredSups.map((s, idx) => (
                    <tr key={s.id || idx} style={{ verticalAlign: 'middle' }}>
                      <td style={{ padding: '8px', textAlign: 'center' }}>
                        <Dropdown as={ButtonGroup}>
                          <Button
                            style={{ backgroundColor: '#007BFF', borderColor: '#007BFF', color: '#FFF', height: '34px', borderRadius: '2px 0 0 2px', fontSize: '0.82rem', fontWeight: '500', padding: '4px 14px' }}
                            onClick={() => handleOpenEditSup(s)}
                          >
                            Action
                          </Button>
                          <Dropdown.Toggle
                            split
                            style={{ backgroundColor: '#0069D9', borderColor: '#0069D9', color: '#FFF', height: '34px', borderRadius: '0 2px 2px 0', padding: '4px 8px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                          >
                            <FontAwesomeIcon icon={faCaretDown} style={{ fontSize: '0.8rem' }} />
                          </Dropdown.Toggle>
                          <Dropdown.Menu style={{ borderRadius: '4px', border: '1px solid #DDD', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                            <Dropdown.Item style={{ padding: '8px 20px', fontSize: '0.9rem', color: '#333' }} onClick={() => handleOpenEditSup(s)}>
                              Modifier
                            </Dropdown.Item>
                            <Dropdown.Item style={{ padding: '8px 20px', fontSize: '0.9rem', color: '#333' }} onClick={() => handleToggleSupStatus(s)}>
                              {s.is_active ? "Desactivé" : "Activé"}
                            </Dropdown.Item>
                            <Dropdown.Item style={{ padding: '8px 20px', fontSize: '0.9rem', color: '#DC3545' }} onClick={() => handleDeleteSupervisor(s.id)}>
                              Supprimer
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                      <td style={{ fontSize: '0.85rem', padding: '8px', textAlign: 'center' }}>
                        <button
                          type="button"
                          onClick={() => openAccessList(s)}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#E05A2B',
                            fontWeight: 700,
                            cursor: 'pointer',
                            padding: 0,
                            textDecoration: 'underline'
                          }}
                        >
                          Liste Accès
                        </button>
                      </td>
                      <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center', fontWeight: 'bold' }}>
                        <div className="d-flex align-items-center justify-content-center" style={{ gap: '8px' }}>
                          <FontAwesomeIcon icon={faUserTie} style={{ color: '#6F42C1' }} />
                          <span>{s.first_name || s.last_name ? `${s.first_name || ''} ${s.last_name || ''}`.trim() : s.username}</span>
                        </div>
                      </td>
                      <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center' }}>{s.username}</td>
                      <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center' }}>
                        {s.managed_branch_name || s.branch_name || <span className="text-muted">Aucune</span>}
                      </td>
                      <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center', fontFamily: 'monospace', fontWeight: 'bold' }}>
                        {s.supervisor_commission_rate != null ? `${Math.round(Number(s.supervisor_commission_rate) || 0)} %` : '—'}
                      </td>
                      <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center' }}>{s.phone_number || "—"}</td>
                      <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center' }}>
                        {s.is_active ? "actif" : "inactif"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          <div className="p-3 d-flex justify-content-between align-items-center border-top">
            <span className="small text-muted fw-bold">Showing 1 to {filteredSups.length} of {filteredSups.length} entries</span>
            <ButtonGroup>
              <Button variant="light" className="border btn-sm text-dark font-weight-bold" style={{ backgroundColor: '#F8F9FA', borderRadius: '2px' }}>Previous</Button>
              <Button variant="light" className="border btn-sm text-dark font-weight-bold px-3" style={{ backgroundColor: '#E0E0E0', borderRadius: '2px' }}>1</Button>
              <Button variant="light" className="border btn-sm text-dark font-weight-bold" style={{ backgroundColor: '#F8F9FA', borderRadius: '2px' }}>Next</Button>
            </ButtonGroup>
          </div>
        </Card>
      ) : (
        /* Branch List View */
        <Card className="border-0 shadow-sm" style={{ borderRadius: '8px' }}>
          <Card.Header className="bg-white border-0 py-3">
            <Row className="align-items-center">
              <Col>
                <h4 style={{ fontWeight: 'bold', color: viewMode === "list-active" ? '#28A745' : '#FFC107', margin: 0, textTransform: 'uppercase' }}>
                  {viewMode === "list-active" ? "SUCCURSALES ACTIVES" : "SUCCURSALES INACTIVES"}
                </h4>
              </Col>
            </Row>
          </Card.Header>

          <div className="px-3 pb-3 d-flex justify-content-between align-items-center flex-wrap" style={{ gap: '10px' }}>
            <div className="d-flex" style={{ gap: '4px' }}>
              {["COPIER", "EXCEL", "PDF", "IMPRIMER"].map((label, idx) => (
                <button
                  key={idx}
                  style={{ backgroundColor: '#F5F5F5', border: '1px solid #CCCCCC', color: '#333333', fontSize: '0.78rem', padding: '6px 16px', borderRadius: '2px', height: '34px', fontWeight: 'normal', outline: 'none' }}
                  onClick={() => alert(`${label} cliqué`)}
                >
                  {label}
                </button>
              ))}
            </div>
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
              <span className="fw-bold small text-dark" style={{ fontSize: '0.92rem' }}>Search:</span>
              <Form.Control
                type="text"
                size="sm"
                style={{ width: '220px', borderRadius: '4px', border: '1px solid #CCC' }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="table-responsive" style={{ padding: '0 16px 16px 16px' }}>
            <Table bordered hover className="align-items-center mb-0" style={{ borderCollapse: 'collapse', borderColor: '#DDD' }}>
              <thead>
                <tr style={{ backgroundColor: '#F8F9FA' }}>
                  <th style={{ width: '90px', padding: '12px 8px', textAlign: 'center' }}></th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Logo
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Nom de Succursale <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Zone / Emplacement <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Superviseur <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Commission Superviseur <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Message Fiche <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                  <th style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#333', padding: '12px 8px', textAlign: 'center' }}>
                    Statut <span style={{ color: '#BBB', fontSize: '0.65rem', marginLeft: '4px' }}>▲▼</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center py-4 text-muted">
                      {viewMode === "list-active" ? "Aucune succursale active trouvée." : "Aucune succursale inactive trouvée."}
                    </td>
                  </tr>
                ) : (
                  filtered.map((b, idx) => {
                    const supDisplayName = getSupervisorName(b);
                    const effLogo = b.branch_logo_url || b.effective_branding?.logo_url || null;
                    const effCompanyName = b.display_name || b.effective_branding?.company_name || "";
                    const effFooter = b.branch_footer_message || b.effective_branding?.ticket_footer_message || "";
                    return (
                      <tr key={b.id || idx} style={{ verticalAlign: 'middle' }}>
                        {/* Action dropdown button */}
                        <td style={{ padding: '8px', textAlign: 'center' }}>
                          {isCompanyAdmin ? (
                          <Dropdown as={ButtonGroup}>
                            <Button
                              style={{ backgroundColor: '#007BFF', borderColor: '#007BFF', color: '#FFF', height: '34px', borderRadius: '2px 0 0 2px', fontSize: '0.82rem', fontWeight: '500', padding: '4px 14px' }}
                              onClick={() => handleOpenEdit(b)}
                            >
                              Action
                            </Button>
                            <Dropdown.Toggle
                              split
                              style={{ backgroundColor: '#0069D9', borderColor: '#0069D9', color: '#FFF', height: '34px', borderRadius: '0 2px 2px 0', padding: '4px 8px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                              <FontAwesomeIcon icon={faCaretDown} style={{ fontSize: '0.8rem' }} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu style={{ borderRadius: '4px', border: '1px solid #DDD', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                              <Dropdown.Item style={{ padding: '8px 20px', fontSize: '0.9rem', color: '#333' }} onClick={() => handleOpenEdit(b)}>Modifier</Dropdown.Item>
                              <Dropdown.Item style={{ padding: '8px 20px', fontSize: '0.9rem', color: '#333' }} onClick={() => handleToggleStatus(b)}>{(b.is_active ?? true) ? "Desactivé" : "Activé"}</Dropdown.Item>
                              <Dropdown.Item style={{ padding: '8px 20px', fontSize: '0.9rem', color: '#DC3545' }} onClick={() => handleDeleteBranch(b.id)}>Supprimer</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          ) : isSupervisorUser ? (
                            <Button
                              size="sm"
                              style={{ backgroundColor: '#007BFF', borderColor: '#007BFF', color: '#FFF', fontSize: '0.8rem' }}
                              onClick={() => handleOpenEdit(b)}
                            >
                              Modifier
                            </Button>
                          ) : (
                            <span className="text-muted small">—</span>
                          )}
                        </td>
                        <td style={{ padding: '8px', textAlign: 'center' }}>
                          {effLogo ? (
                            <img
                              src={effLogo}
                              alt={b.name}
                              style={{ height: '32px', width: '32px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #EEE', background: '#FFF' }}
                            />
                          ) : (
                            <span className="text-muted small">—</span>
                          )}
                        </td>
                        <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center', fontWeight: 'bold' }}>
                          <div className="d-flex align-items-center justify-content-center" style={{ gap: '8px' }}>
                            <FontAwesomeIcon icon={faBuilding} style={{ color: '#007BFF' }} />
                            <span>{b.name}</span>
                          </div>
                          {effCompanyName && (
                            <div className="small text-muted fw-normal mt-1" style={{ fontSize: '0.75rem' }}>
                              Borlette: <strong style={{ color: '#007BFF' }}>{effCompanyName}</strong>
                            </div>
                          )}
                        </td>
                        <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center' }}>{b.zone_name || "—"}</td>
                        <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center' }}>
                          {supDisplayName ? (
                            <div className="d-flex align-items-center justify-content-center" style={{ gap: '6px' }}>
                              <FontAwesomeIcon icon={faUserTie} style={{ color: '#6F42C1', fontSize: '0.8rem' }} />
                              <span>{supDisplayName}</span>
                            </div>
                          ) : (
                            <span className="text-muted italic">Aucun</span>
                          )}
                        </td>
                        <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center', fontFamily: 'monospace', fontWeight: 'bold' }}>
                          {b.supervisor_commission_rate != null ? `${Math.round(Number(b.supervisor_commission_rate) || 0)} %` : '—'}
                        </td>
                        <td style={{ fontSize: '0.8rem', color: '#555', padding: '8px', textAlign: 'center', maxWidth: '200px' }}>
                          {effFooter ? (
                            <span title={effFooter}>
                              {effFooter.length > 40 ? `${effFooter.slice(0, 40)}...` : effFooter}
                            </span>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                        <td style={{ fontSize: '0.85rem', color: '#333', padding: '8px', textAlign: 'center' }}>
                          {(b.is_active ?? true) ? "actif" : "inactif"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>

          <div className="p-3 d-flex justify-content-between align-items-center border-top">
            <span className="small text-muted fw-bold">Showing 1 to {filtered.length} of {filtered.length} entries</span>
            <ButtonGroup>
              <Button variant="light" className="border btn-sm text-dark font-weight-bold" style={{ backgroundColor: '#F8F9FA', borderRadius: '2px' }}>Previous</Button>
              <Button variant="light" className="border btn-sm text-dark font-weight-bold px-3" style={{ backgroundColor: '#E0E0E0', borderRadius: '2px' }}>1</Button>
              <Button variant="light" className="border btn-sm text-dark font-weight-bold" style={{ backgroundColor: '#F8F9FA', borderRadius: '2px' }}>Next</Button>
            </ButtonGroup>
          </div>
        </Card>
      )}

      {/* Edit Branch Modal */}
      <Modal as={Modal.Dialog} size="lg" centered show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header>
          <Modal.Title className="h6 font-bold">Modifier Succursale</Modal.Title>
          <Button variant="close" onClick={() => setShowEditModal(false)} />
        </Modal.Header>
        <Form onSubmit={handleSaveEdit}>
          <Modal.Body>
            {editError && <Alert variant="danger" className="py-2 px-3 small mb-2">{editError}</Alert>}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small mb-1">Nom de la succursale *</Form.Label>
                  <Form.Control
                    type="text"
                    value={editForm.name}
                    onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
                    disabled={!isCompanyAdmin}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small mb-1">Zone / Emplacement</Form.Label>
                  <Form.Control
                    type="text"
                    value={editForm.zone_name}
                    onChange={(e) => setEditForm({ ...editForm, zone_name: e.target.value })}
                    disabled={!isCompanyAdmin}
                  />
                </Form.Group>
              </Col>
            </Row>
            {isCompanyAdmin && (
              <>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold small mb-1">Superviseur</Form.Label>
                      <Form.Control as="select" value={editForm.supervisor} onChange={(e) => setEditForm({ ...editForm, supervisor: e.target.value })}>
                        <option value="">Sélectionner un superviseur...</option>
                        {supervisors.map(s => (
                          <option key={s.id} value={s.id}>
                            {s.first_name || s.last_name ? `${s.first_name} ${s.last_name} (${s.username})` : s.username}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold small mb-1">% Commission Superviseur</Form.Label>
                      <div className="position-relative d-flex align-items-center">
                        <Form.Control
                          type="number"
                          step="0.01"
                          min="0"
                          style={{ paddingRight: '48px' }}
                          value={editForm.supervisor_commission_rate}
                          onChange={(e) => setEditForm({ ...editForm, supervisor_commission_rate: e.target.value })}
                        />
                        <span style={{ position: 'absolute', right: '12px', fontSize: '0.85rem', color: '#888', fontWeight: 'bold' }}>%</span>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Check type="checkbox" id="edit-active-switch" label="Succursale Active" checked={editForm.is_active} onChange={(e) => setEditForm({ ...editForm, is_active: e.target.checked })} />
                </Form.Group>
              </>
            )}

            {/* Section Branding & Fiche de la Succursale */}
            <div className="border rounded p-3 mt-2" style={{ backgroundColor: '#FAFAFA', borderColor: '#E5E5E5' }}>
              <h6 className="fw-bold mb-1" style={{ color: '#007BFF' }}>
                Branding & Fiche de la Succursale (Optionnel)
              </h6>
              <div className="text-muted small mb-3">
                Si un champ est vide, la valeur de la compagnie est utilisée automatiquement.
              </div>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold small mb-1">Nom Borlette / Nom Bank affiché</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Hérité de la compagnie si vide"
                      value={editForm.display_name}
                      onChange={(e) => setEditForm({ ...editForm, display_name: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold small mb-1">Logo de la succursale</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files?.[0] || null;
                        setEditLogoFile(file);
                        setRemoveEditLogo(false);
                        setEditLogoPreview(file ? URL.createObjectURL(file) : editForm.branch_logo_url);
                      }}
                    />
                    {(editLogoPreview && !removeEditLogo) && (
                      <div className="mt-2 d-flex align-items-center" style={{ gap: '10px' }}>
                        <img
                          src={editLogoPreview}
                          alt="Logo succursale"
                          style={{ height: '40px', width: 'auto', borderRadius: '4px', border: '1px solid #DDD', padding: '2px', background: '#FFF' }}
                        />
                        <Button
                          variant="outline-danger"
                          size="sm"
                          type="button"
                          onClick={() => {
                            setEditLogoFile(null);
                            setEditLogoPreview(null);
                            setRemoveEditLogo(true);
                          }}
                        >
                          Supprimer logo personnalisé
                        </Button>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold small mb-1">Téléphone de la succursale</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Hérité de la compagnie si vide"
                      value={editForm.branch_phone}
                      onChange={(e) => setEditForm({ ...editForm, branch_phone: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold small mb-1">Adresse de la succursale</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Héritée de la compagnie si vide"
                      value={editForm.branch_address}
                      onChange={(e) => setEditForm({ ...editForm, branch_address: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold small mb-1">Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={editForm.branch_description}
                      onChange={(e) => setEditForm({ ...editForm, branch_description: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold small mb-1">Message Fiche / Footer du ticket</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Hérité de la compagnie si vide"
                      value={editForm.branch_footer_message}
                      onChange={(e) => setEditForm({ ...editForm, branch_footer_message: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>Annuler</Button>
            <Button type="submit" disabled={saving} style={{ backgroundColor: '#28A745', borderColor: '#28A745', color: '#FFF' }}>
              {saving ? 'Sauvegarde...' : 'Sauvegarder'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Edit Supervisor Modal */}
      <Modal as={Modal.Dialog} centered show={showEditSupModal} onHide={() => setShowEditSupModal(false)}>
        <Modal.Header>
          <Modal.Title className="h6 font-bold">Modifier Superviseur</Modal.Title>
          <Button variant="close" onClick={() => setShowEditSupModal(false)} />
        </Modal.Header>
        <Form onSubmit={handleSaveEditSup}>
          <Modal.Body>
            {editSupError && <Alert variant="danger" className="py-2 px-3 small mb-2">{editSupError}</Alert>}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small mb-1">Prénom</Form.Label>
                  <Form.Control type="text" value={editSupForm.first_name} onChange={(e) => setEditSupForm({ ...editSupForm, first_name: e.target.value })} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small mb-1">Nom</Form.Label>
                  <Form.Control type="text" value={editSupForm.last_name} onChange={(e) => setEditSupForm({ ...editSupForm, last_name: e.target.value })} />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold small mb-1">Nom d'utilisateur *</Form.Label>
              <Form.Control type="text" value={editSupForm.username} onChange={(e) => setEditSupForm({ ...editSupForm, username: e.target.value })} required />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small mb-1">Nouveau mot de passe</Form.Label>
                  <Form.Control type="password" value={editSupForm.password} onChange={(e) => setEditSupForm({ ...editSupForm, password: e.target.value })} placeholder="Laisser vide = inchangé" />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small mb-1">Confirmer</Form.Label>
                  <Form.Control type="password" value={editSupForm.confirm_password} onChange={(e) => setEditSupForm({ ...editSupForm, confirm_password: e.target.value })} />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold small mb-1">Succursale</Form.Label>
              <Form.Control
                as="select"
                value={editSupForm.branch}
                onChange={(e) => {
                  const branchId = e.target.value;
                  const br = branches.find(b => String(b.id) === String(branchId));
                  setEditSupForm({
                    ...editSupForm,
                    branch: branchId,
                    supervisor_commission_rate: br?.supervisor_commission_rate != null
                      ? String(br.supervisor_commission_rate)
                      : editSupForm.supervisor_commission_rate
                  });
                }}
              >
                <option value="">Sélectionner une succursale...</option>
                {branches.map(b => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold small mb-1">% Commission Superviseur</Form.Label>
              <div className="position-relative d-flex align-items-center">
                <Form.Control
                  type="number"
                  step="0.01"
                  min="0"
                  style={{ paddingRight: '48px' }}
                  value={editSupForm.supervisor_commission_rate}
                  onChange={(e) => setEditSupForm({ ...editSupForm, supervisor_commission_rate: e.target.value })}
                />
                <span style={{ position: 'absolute', right: '12px', fontSize: '0.85rem', color: '#888', fontWeight: 'bold' }}>%</span>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold small mb-1">Téléphone</Form.Label>
              <Form.Control type="text" value={editSupForm.phone_number} onChange={(e) => setEditSupForm({ ...editSupForm, phone_number: e.target.value })} />
            </Form.Group>
            <Form.Group>
              <Form.Check type="checkbox" id="edit-sup-active" label="Superviseur Actif" checked={editSupForm.is_active} onChange={(e) => setEditSupForm({ ...editSupForm, is_active: e.target.checked })} />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditSupModal(false)}>Annuler</Button>
            <Button type="submit" disabled={saving} style={{ backgroundColor: '#28A745', borderColor: '#28A745', color: '#FFF' }}>
              {saving ? 'Sauvegarde...' : 'Sauvegarder'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Branches;
